// @ts-nocheck
// Wizualna Chemia™ — Edycja 2026 (Polonia)
// Pegar este archivo completo reemplazando el contenido de App.tsx en Magic Patterns.
import { useEffect } from "react";
const CSS = `
:root{
  --navy:#0b1b3a; --petrol:#0f6a82; --blue:#2563eb; --turq:#14b8a6;
  --green:#16a34a; --green-d:#15803d; --gold:#f5b83d;
  --bg:#eef8fb; --ice:#ddf1f6; --card:#fff; --text:#334155; --muted:#64748b; --line:#dbe7ee;
  --r:20px; --shadow:0 10px 30px -12px rgba(11,27,58,.18);
}
*{box-sizing:border-box;margin:0;padding:0}
html{scroll-behavior:smooth}
body{font-family:Inter,system-ui,sans-serif;color:var(--text);background:var(--bg);line-height:1.55;-webkit-font-smoothing:antialiased;overflow-x:hidden}
img{max-width:100%;display:block}
h1,h2,h3,.ff{font-family:Poppins,Inter,sans-serif;color:var(--navy);line-height:1.15;letter-spacing:-.01em}
h1{font-size:clamp(2rem,6vw,3.4rem);font-weight:900}
h2{font-size:clamp(1.6rem,4.2vw,2.5rem);font-weight:800}
h3{font-size:1.08rem;font-weight:700}
.accent{color:var(--blue)}
.wrap{max-width:1100px;margin:0 auto;padding:0 16px}
.narrow{max-width:780px;margin:0 auto}
section{padding:64px 0}
.center{text-align:center}
.lead{font-size:1.1rem;color:var(--muted);max-width:720px;margin:14px auto 0}
.eyebrow{display:inline-flex;align-items:center;gap:6px;font-size:.78rem;font-weight:700;letter-spacing:.08em;text-transform:uppercase;color:var(--petrol);margin-bottom:12px}
.pill{display:inline-block;padding:6px 14px;border-radius:999px;background:#fff;border:1px solid var(--line);font-size:.85rem;font-weight:600;color:var(--petrol)}
.grid{display:grid;gap:18px}
.g2{grid-template-columns:repeat(auto-fit,minmax(280px,1fr))}
.g3{grid-template-columns:repeat(auto-fit,minmax(250px,1fr))}
.g4{grid-template-columns:repeat(auto-fit,minmax(200px,1fr))}
.card{background:var(--card);border-radius:var(--r);padding:24px;box-shadow:var(--shadow);border:1px solid #fff}
.num{width:36px;height:36px;border-radius:50%;background:var(--petrol);color:#fff;font-weight:700;display:grid;place-items:center;font-size:.85rem;margin-bottom:14px}
.card p{font-size:.95rem;color:var(--muted);margin-top:6px}

/* Botones */
.btn{display:inline-flex;align-items:center;justify-content:center;gap:8px;background:var(--green);color:#fff;font-family:Poppins,sans-serif;font-weight:800;text-transform:uppercase;font-size:1.05rem;padding:18px 34px;border-radius:16px;text-decoration:none;box-shadow:0 12px 28px -8px rgba(22,163,74,.55);transition:transform .15s,background .15s;border:0;cursor:pointer;text-align:center}
.btn:hover{background:var(--green-d);transform:translateY(-2px)}
.btn.big{font-size:1.2rem;padding:22px 36px;width:100%;max-width:640px}
.cta-note{font-size:.88rem;color:var(--petrol);font-weight:600;margin-top:12px}
.cta-sub{font-size:.82rem;color:var(--muted);margin-top:6px}

/* Nota BLIK debajo de los botones de pago */
.blik{display:flex;flex-direction:column;align-items:center;gap:4px;margin:14px auto 0;text-align:center;font-size:.92rem;line-height:1.35;color:var(--text)}
.blik .fila{display:inline-flex;align-items:center;gap:8px;flex-wrap:wrap;justify-content:center}
.blik-logo{display:inline-block;background:#000;color:#fff;font-family:Poppins,sans-serif;font-weight:800;font-size:.75rem;letter-spacing:.06em;padding:4px 9px;border-radius:6px;line-height:1}
.blik .sub{font-size:.82rem;color:var(--muted)}
.final .blik{color:#e2e8f0}
.final .blik .sub{color:#94a3b8}
.final .blik-logo{background:#fff;color:#000}

/* Barra superior */
.topbar{background:var(--navy);color:#fff;font-size:.85rem;font-weight:600;text-align:center;padding:9px 16px}

/* Hero */
.hero{padding:44px 0 56px;background:linear-gradient(180deg,#f3fbfd 0%,var(--bg) 100%)}
.hero .sub{font-size:clamp(1.05rem,2.4vw,1.25rem);font-weight:600;color:var(--navy);max-width:760px;margin:18px auto 0}
.hero .desc{color:var(--muted);max-width:700px;margin:12px auto 22px}
.mock{max-width:760px;margin:0 auto;border-radius:28px;overflow:hidden;box-shadow:0 30px 60px -20px rgba(11,27,58,.35);border:1px solid #fff}
.mock-cap{font-family:Poppins,sans-serif;font-weight:700;color:var(--petrol);margin-top:16px}
.chips{display:flex;flex-wrap:wrap;gap:8px;justify-content:center;margin:22px 0 0}
.stats{margin-top:34px}
.stats .card{padding:18px;text-align:center}
.stats b{display:block;font-family:Poppins,sans-serif;font-weight:900;font-size:2rem;color:var(--petrol);line-height:1}
.stats span{display:block;margin-top:6px;font-family:Poppins,sans-serif;font-weight:700;color:var(--navy);font-size:.82rem;text-transform:uppercase;letter-spacing:.04em}

/* Comparación */
.compare{background:var(--ice)}
.vs .bad{background:#f8fbfc}
.vs .good{background:var(--petrol);color:#fff}
.vs .good h3{color:#fff}
.vs ul{list-style:none;margin-top:16px;display:grid;gap:14px}
.vs li{display:flex;gap:12px;align-items:flex-start;font-size:.97rem}
.vs li i{flex:0 0 26px;height:26px;border-radius:8px;display:grid;place-items:center;font-style:normal;font-weight:700;font-size:.85rem}
.vs .bad li i{background:#e2e8f0;color:#475569}
.vs .good li i{background:rgba(20,184,166,.25);color:#99f6e4}

/* Tomy */
.vol{display:flex;flex-direction:column;padding:0;overflow:hidden}
.vol img{width:100%;height:auto;background:#f8fafc}
.vol .in{padding:18px 20px 22px}
.vol .n{font-family:Poppins,sans-serif;font-weight:900;color:var(--turq);font-size:.9rem;letter-spacing:.08em}
.vol h3{margin-top:4px}
.tag-in{display:inline-block;margin-top:12px;background:var(--ice);color:var(--petrol);font-size:.72rem;font-weight:800;letter-spacing:.06em;padding:5px 10px;border-radius:999px;text-transform:uppercase}

/* Bonusy */
.bonus{background:var(--navy)}
.bonus h2{color:#fff}
.bonus .lead{color:#cbd5e1}
.bonus .card{background:rgba(255,255,255,.06);border:1px solid rgba(255,255,255,.12);box-shadow:none}
.bonus .card h3{color:#fff}
.bonus .card p{color:#cbd5e1}
.bonus .bn{display:inline-block;background:var(--gold);color:var(--navy);font-weight:800;font-size:.72rem;letter-spacing:.08em;padding:5px 12px;border-radius:999px;margin-bottom:12px}
.bonus .tag-in{background:rgba(20,184,166,.18);color:#99f6e4}

/* Oferta */
.offer-sec{background:var(--ice)}
.offer{max-width:680px;margin:30px auto 0;border:2px solid var(--petrol);border-radius:26px;background:#fff;padding:30px 24px;box-shadow:var(--shadow);text-align:left}
.offer h3{font-size:1.35rem;margin-bottom:4px}
.offer ul{list-style:none;margin:18px 0;display:grid;gap:10px}
.offer li{display:flex;gap:10px;font-size:1rem}
.offer li::before{content:"✓";color:var(--green);font-weight:800}
.offer li.b{font-weight:600;color:var(--navy)}
.totals{display:grid;grid-template-columns:1fr 1fr;gap:12px;margin:6px 0 18px}
.totals div{background:var(--ice);border-radius:14px;padding:14px;text-align:center}
.totals b{display:block;font-family:Poppins,sans-serif;font-weight:900;font-size:1.7rem;color:var(--petrol);line-height:1}
.totals span{font-size:.82rem;color:var(--muted);font-weight:600}
.pricebox{border-top:1px solid var(--line);padding-top:18px;text-align:center}
.pricebox .promo{display:inline-block;background:var(--green);color:#fff;font-size:.75rem;font-weight:800;letter-spacing:.06em;padding:5px 12px;border-radius:999px;text-transform:uppercase}
.pricebox .old{margin-top:10px;color:var(--muted);font-weight:600}
.pricebox .old s{font-weight:700}
.pricebox .now{font-family:Poppins,sans-serif;font-weight:900;font-size:clamp(2.4rem,8vw,3.2rem);color:var(--navy);line-height:1.1;margin-top:4px}
.pricebox .save{color:var(--green);font-weight:700;margin-top:2px}
.pricebox .once{font-size:.88rem;color:var(--muted);margin:8px 0 18px}

/* Contador de 15 minutos */
.timer{max-width:440px;margin:16px auto 6px;background:#fff7ed;border:2px solid #f97316;border-radius:18px;padding:16px 14px}
.timer p{font-weight:700;color:#9a3412;font-size:.95rem;line-height:1.35}
.timer .clock{display:flex;justify-content:center;align-items:center;gap:8px;margin-top:10px}
.timer .box{background:#fff;border-radius:12px;padding:6px 14px;min-width:78px;box-shadow:0 6px 14px -8px rgba(154,52,18,.45)}
.timer .box b{display:block;font-family:Poppins,sans-serif;font-weight:900;font-size:2.3rem;color:#c2410c;line-height:1.05}
.timer .box small{display:block;font-size:.66rem;font-weight:800;letter-spacing:.1em;color:#9a3412}
.timer .sep{font-family:Poppins,sans-serif;font-weight:900;font-size:2rem;color:#c2410c}
.timer .fin{display:none;margin-top:10px;font-size:.88rem}
.timer.ultimo{animation:alerta 1s ease-in-out infinite}
.timer.cero .fin{display:block}
@keyframes alerta{0%,100%{border-color:#f97316}50%{border-color:#dc2626;box-shadow:0 0 0 4px rgba(220,38,38,.15)}}
.sticky .p small b{color:#c2410c}

/* Carrusel */
.car{position:relative;max-width:900px;margin:30px auto 0}
.track{display:flex;overflow-x:auto;scroll-snap-type:x mandatory;gap:16px;scrollbar-width:none;border-radius:24px}
.track::-webkit-scrollbar{display:none}
.slide{flex:0 0 100%;scroll-snap-align:center;background:#fff;border-radius:24px;padding:18px;box-shadow:var(--shadow)}
.slide img{width:100%;height:auto;max-height:560px;object-fit:contain;border-radius:12px;background:#f8fafc}
.slide p{text-align:center;font-family:Poppins,sans-serif;font-weight:700;color:var(--navy);margin-top:12px}
.slide small{display:block;text-align:center;color:var(--muted);font-weight:600;letter-spacing:.06em;font-size:.72rem;text-transform:uppercase}
.arr{position:absolute;top:45%;transform:translateY(-50%);width:46px;height:46px;border-radius:50%;background:#fff;border:0;box-shadow:var(--shadow);font-size:1.3rem;color:var(--petrol);cursor:pointer;z-index:2}
.arr.prev{left:-10px}.arr.next{right:-10px}
.dots{display:flex;justify-content:center;gap:7px;margin-top:16px}
.dots button{width:9px;height:9px;border-radius:99px;border:0;background:#b6cbd5;cursor:pointer;transition:width .2s}
.dots button.on{width:26px;background:var(--petrol)}

/* Dla kogo */
.fit ul{list-style:none;margin-top:16px;display:grid;gap:12px}
.fit li{display:flex;gap:10px;align-items:flex-start;font-size:.97rem}
.fit li::before{flex:0 0 24px;height:24px;border-radius:50%;display:grid;place-items:center;font-size:.8rem;font-weight:800}
.fit .yes li::before{content:"✓";background:var(--green);color:#fff}
.fit .no li::before{content:"✕";background:#e2e8f0;color:#475569}

/* FAQ */
.faq details{background:#fff;border-radius:16px;margin-bottom:12px;box-shadow:0 4px 14px -8px rgba(11,27,58,.15)}
.faq summary{list-style:none;cursor:pointer;padding:20px 22px;font-family:Poppins,sans-serif;font-weight:700;color:var(--navy);display:flex;justify-content:space-between;gap:16px}
.faq summary::-webkit-details-marker{display:none}
.faq summary::after{content:"+";color:var(--petrol);font-size:1.4rem;line-height:1}
.faq details[open] summary::after{content:"–"}
.faq details p{padding:0 22px 20px;color:var(--muted)}

/* Cierre */
.final{background:var(--navy);color:#cbd5e1;text-align:center}
.final h2{color:#fff;font-size:clamp(1.8rem,5vw,3rem);font-weight:900}
.final .sub{color:var(--turq);font-weight:700;font-size:1.1rem;margin-top:14px;font-family:Poppins,sans-serif}
.final ul{list-style:none;display:grid;gap:8px;width:fit-content;max-width:100%;margin:24px auto 28px;text-align:left}
.final li{display:flex;gap:10px}
.final li::before{content:"✓";color:var(--turq);font-weight:800}
.final .meta{font-size:.78rem;letter-spacing:.08em;text-transform:uppercase;color:#94a3b8;margin-top:18px;font-weight:600}
footer{background:var(--navy);border-top:1px solid rgba(255,255,255,.08);text-align:center;padding:34px 16px 110px;color:#94a3b8;font-size:.8rem}
footer b{color:var(--turq);letter-spacing:.1em;font-family:Poppins,sans-serif}

/* Barra fija móvil */
.sticky{position:fixed;left:0;right:0;bottom:0;background:#fff;border-top:1px solid var(--line);box-shadow:0 -8px 24px -12px rgba(11,27,58,.25);padding:10px 16px;display:flex;align-items:center;justify-content:space-between;gap:12px;z-index:50;transform:translateY(110%);transition:transform .25s}
.sticky.show{transform:none}
.sticky .p{font-family:Poppins,sans-serif;font-weight:800;color:var(--navy);font-size:1.05rem;line-height:1.1}
.sticky .p small{display:block;font-family:Inter,sans-serif;font-weight:500;font-size:.72rem;color:var(--muted)}
.sticky .btn{padding:13px 18px;font-size:.9rem;border-radius:12px;white-space:nowrap}

/* ===== INTERACCIÓN ===== */
/* Capa de partículas: no bloquea clics y queda muy tenue para no tapar el texto */
#particulas{position:fixed;inset:0;pointer-events:none;z-index:40;overflow:hidden}
.pt{position:absolute;opacity:var(--o,.16);animation:flotar var(--t,26s) ease-in-out infinite alternate;will-change:transform}
.pt svg{display:block;width:100%;height:100%}
@keyframes flotar{
  0%{transform:translate(0,0) rotate(0)}
  33%{transform:translate(var(--dx1),var(--dy1)) rotate(40deg)}
  66%{transform:translate(var(--dx2),var(--dy2)) rotate(-25deg)}
  100%{transform:translate(var(--dx3),var(--dy3)) rotate(15deg)}
}
.orb{transform-origin:50px 50px;animation:girar var(--g,6s) linear infinite}
.orb.r{animation-direction:reverse}
@keyframes girar{to{transform:rotate(360deg)}}

/* Botones CTA: pulso suave + brillo que cruza + flecha que se mueve */
.btn{position:relative;overflow:hidden;animation:pulso 2.6s ease-in-out infinite}
.btn::after{content:"";position:absolute;top:0;left:-60%;width:40%;height:100%;background:linear-gradient(110deg,transparent,rgba(255,255,255,.45),transparent);transform:skewX(-20deg);animation:brillo 3.8s ease-in-out infinite}
.btn .fl{display:inline-block;transition:transform .2s;animation:empuje 1.6s ease-in-out infinite}
.btn:hover{transform:translateY(-3px) scale(1.02)}
.btn:active{transform:scale(.97)}
@keyframes pulso{0%,100%{box-shadow:0 12px 28px -8px rgba(22,163,74,.55),0 0 0 0 rgba(22,163,74,.45)}50%{box-shadow:0 12px 28px -8px rgba(22,163,74,.55),0 0 0 12px rgba(22,163,74,0)}}
@keyframes brillo{0%,55%{left:-60%}85%,100%{left:130%}}
@keyframes empuje{0%,100%{transform:translateX(0)}50%{transform:translateX(5px)}}

/* Tarjetas: se elevan al pasar el mouse */
.card,.slide{transition:transform .25s,box-shadow .25s}
.card:hover{transform:translateY(-5px);box-shadow:0 22px 40px -18px rgba(11,27,58,.3)}

/* Imagen principal flotando con un átomo orbitando detrás */
.mock-wrap{position:relative;max-width:760px;margin:40px auto 0}
.mock-wrap .mock{margin:0;animation:levitar 6s ease-in-out infinite;position:relative;z-index:1}
.mock-wrap .anillo{position:absolute;inset:-6%;border:2px dashed rgba(37,99,235,.25);border-radius:50%;animation:girar 40s linear infinite}
.mock-wrap .anillo i{position:absolute;top:-9px;left:50%;width:18px;height:18px;border-radius:50%;background:var(--turq);box-shadow:0 0 14px var(--turq)}
@keyframes levitar{0%,100%{transform:translateY(0)}50%{transform:translateY(-10px)}}

/* Aparición al hacer scroll (solo si hay JS) */
.js .rv{opacity:0;transform:translateY(26px);transition:opacity .7s ease,transform .7s ease}
.js .rv.in{opacity:1;transform:none}

/* Respeta a quien prefiere menos movimiento */
@media (prefers-reduced-motion:reduce){
  *,*::before,*::after{animation:none!important;transition:none!important}
  #particulas{display:none}
  .js .rv{opacity:1;transform:none}
}

@media (max-width:760px){
  section{padding:48px 0}
  .mock-wrap .anillo{display:none}
  .arr{display:none}
  .btn{width:100%}
  .stats{grid-template-columns:1fr 1fr;gap:12px}
  .vol{flex-direction:row;align-items:flex-start}
  .vol img{width:110px;flex:0 0 110px;margin:14px 0 14px 14px;border-radius:10px}
  .vol .in{padding:14px 16px 16px}
}
@media (min-width:761px){.sticky{display:none}}
`;

// Nota de BLIK reutilizable (debajo de cada botón que va al pago)
const BLIK = `<div class="blik"><span class="fila"><span class="blik-logo">BLIK</span><span><b>Zapłać BLIK-iem</b> — wystarczy kod z aplikacji banku.</span></span><span class="sub">🔒 Bezpieczna płatność • Dostęp od razu po zakupie</span></div>`;
const CHECKOUT = "https://wizualna-chemia.impultienda.ar/checkout";
const MARKUP = `<div class="topbar">🇵🇱 Dla nauczycieli chemii w Polsce • Materiały cyfrowe do pobrania • Dostęp od razu</div>

<!-- HERO -->
<header class="hero center">
  <div class="wrap">
    <span class="pill">🧪 Gotowe do użycia materiały dla nauczycieli chemii</span>
    <h1 style="margin-top:18px">Cały rok chemii — <span class="accent">uporządkowany, wizualny i gotowy na Twoją następną lekcję.</span></h1>
    <p class="sub">7 kompletnych tomów i 3 bonusy, które pomagają uczyć klasy 7–8, liceum i technikum bez tworzenia materiałów od zera.</p>
    <p class="desc">568 stron gotowych do wydruku: jasne wyjaśnienia, ćwiczenia, sprawdziany, projekty, klucze odpowiedzi i materiały dla nauczyciela — wszystko po polsku.</p>

    <a class="btn big cta" href="#oferta">Uzyskaj natychmiastowy dostęp</a>
    <p class="cta-note">Jednorazowa płatność • Bez abonamentu • Płatność BLIK</p>

    <div class="mock-wrap">
      <div class="anillo"><i></i></div>
      <div class="mock">
        <img src="https://cdn.magicpatterns.com/uploads/wu4SNSxcoVYTPsMHspiMVi/chemia-wizualna-hero-pl-16x9.webp" alt="Wizualna Chemia™ — Edycja 2026: 7 tomów i 3 bonusy" width="1600" height="900">
      </div>
    </div>
    <p class="mock-cap">Wizualna Chemia™ | Edycja 2026</p>

    <div class="grid g4 stats">
      <div class="card"><b>7</b><span>tomów</span></div>
      <div class="card"><b>3</b><span>bonusy</span></div>
      <div class="card"><b>568</b><span>stron</span></div>
      <div class="card"><b>2026</b><span>edycja</span></div>
    </div>
    <div class="chips">
      <span class="pill">Materiały po polsku</span><span class="pill">Gotowe do druku</span><span class="pill">Klasy 7–8, liceum i technikum</span>
    </div>
  </div>
</header>

<!-- PROBLEM / ROZWIĄZANIE -->
<section class="compare">
  <div class="wrap">
    <div class="center narrow">
      <h2>Nie musisz już spędzać wieczorów na składaniu lekcji chemii z przypadkowych plików.</h2>
    </div>
    <div class="grid g2 vs" style="margin-top:30px">
      <div class="card bad">
        <h3>Gdy wszystko tworzysz samodzielnie</h3>
        <ul>
          <li><i>✕</i>Każdy nowy dział oznacza kolejne notatki, ćwiczenia i sprawdzian.</li>
          <li><i>✕</i>Materiały są rozproszone po folderach i stronach internetowych.</li>
          <li><i>✕</i>Trudne pojęcia wymagają długich wyjaśnień.</li>
          <li><i>✕</i>Planowanie zaczyna się od nowa co tydzień.</li>
        </ul>
      </div>
      <div class="card good">
        <h3>Z Wizualną Chemią™</h3>
        <ul>
          <li><i>✓</i>Prowadzisz uczniów przez spójną kolejność tematów.</li>
          <li><i>✓</i>Masz wizualne strony teorii oraz gotowe zadania do wydruku.</li>
          <li><i>✓</i>Korzystasz ze sprawdzianów, kluczy i planów zamiast tworzyć je od zera.</li>
          <li><i>✓</i>Dopasowujesz materiały do pracy indywidualnej, grupowej, powtórki lub oceny.</li>
        </ul>
      </div>
    </div>
  </div>
</section>

<!-- SYSTEM -->
<section>
  <div class="wrap center narrow">
    <span class="eyebrow">⚛️ Wszystko w jednym systemie</span>
    <h2>Wszystko, czego potrzebujesz, aby uczyć chemii jaśniej i sprawniej.</h2>
    <p class="lead"><b style="color:var(--navy)">Wizualna Chemia™ — Kompletny System Materiałów do Nauczania Chemii.</b> Od budowy atomu po doświadczenia laboratoryjne: otrzymujesz uporządkowaną bibliotekę materiałów, która pomaga wyjaśniać abstrakcyjne zagadnienia za pomocą schematów, ćwiczeń i zastosowań.</p>
  </div>
</section>

<!-- 7 TOMÓW -->
<section style="padding-top:0">
  <div class="wrap">
    <div class="center narrow">
      <h2>7 kompletnych tomów</h2>
      <p class="lead">Spójna kolejność tematów — od budowy atomu po doświadczenia laboratoryjne.</p>
    </div>
    <div class="grid g3" style="margin-top:30px">
      <div class="card vol"><img loading="lazy" src="https://cdn.magicpatterns.com/uploads/6KMvRMQ4a42DYjjhMQtgwt/chemia-wizualna-tom-01-budowa-atomu-i-uklad-okresowy.webp" alt="Tom 01 — Budowa atomu i układ okresowy"><div class="in"><span class="n">TOM 01</span><h3>Budowa atomu i układ okresowy</h3><p>Atom, pierwiastki, cząstki subatomowe, konfiguracje i układ okresowy przedstawione krok po kroku.</p><span class="tag-in">W cenie pakietu</span></div></div>
      <div class="card vol"><img loading="lazy" src="https://cdn.magicpatterns.com/uploads/5rkYouGzH2rtZZkKe4tXYg/chemia-wizualna-tom-02-wiazania-chemiczne-i-hybrydyzacja.webp" alt="Tom 02 — Wiązania chemiczne i hybrydyzacja"><div class="in"><span class="n">TOM 02</span><h3>Wiązania chemiczne i hybrydyzacja</h3><p>Wiązania, struktury i modele pomagające uczniom zrozumieć, jak i dlaczego atomy łączą się ze sobą.</p><span class="tag-in">W cenie pakietu</span></div></div>
      <div class="card vol"><img loading="lazy" src="https://cdn.magicpatterns.com/uploads/7eyMw8uYfcELXwe3AdUHUS/chemia-wizualna-tom-03-reakcje-chemiczne.webp" alt="Tom 03 — Reakcje chemiczne"><div class="in"><span class="n">TOM 03</span><h3>Reakcje chemiczne</h3><p>Rozpoznawanie, zapisywanie i analizowanie reakcji chemicznych w jasnej, uporządkowanej formie.</p><span class="tag-in">W cenie pakietu</span></div></div>
      <div class="card vol"><img loading="lazy" src="https://cdn.magicpatterns.com/uploads/vmAwgfahhtXKP99wjWizHp/chemia-wizualna-tom-04-roztwory-i-stezenia.webp" alt="Tom 04 — Roztwory i stężenia"><div class="in"><span class="n">TOM 04</span><h3>Roztwory i stężenia</h3><p>Roztwory, obliczenia i stężenia przedstawione w sposób wizualny, praktyczny i możliwy do przećwiczenia.</p><span class="tag-in">W cenie pakietu</span></div></div>
      <div class="card vol"><img loading="lazy" src="https://cdn.magicpatterns.com/uploads/7EKDB7icQteSr8USpXd36b/chemia-wizualna-tom-05-kwasy-zasady-i-ph.webp" alt="Tom 05 — Kwasy, zasady i pH"><div class="in"><span class="n">TOM 05</span><h3>Kwasy, zasady i pH</h3><p>pH, pOH, wskaźniki, bufory i miareczkowanie z przykładami, obliczeniami i zadaniami.</p><span class="tag-in">W cenie pakietu</span></div></div>
      <div class="card vol"><img loading="lazy" src="https://cdn.magicpatterns.com/uploads/8L5Hv2wT4sdjVP5kXzWE1y/chemia-wizualna-tom-06-chemia-organiczna.webp" alt="Tom 06 — Chemia organiczna"><div class="in"><span class="n">TOM 06</span><h3>Chemia organiczna</h3><p>Podstawy chemii organicznej uporządkowane tak, aby uczniowie mogli zobaczyć związki, zależności i zastosowania.</p><span class="tag-in">W cenie pakietu</span></div></div>
      <div class="card vol"><img loading="lazy" src="https://cdn.magicpatterns.com/uploads/2vN6nvLeUHB9jErPCP2X8A/chemia-wizualna-tom-07-doswiadczenia-i-projekty-laboratoryjne.webp" alt="Tom 07 — Doświadczenia laboratoryjne i projekty"><div class="in"><span class="n">TOM 07</span><h3>Doświadczenia laboratoryjne i projekty</h3><p>Gotowe inspiracje do doświadczeń, pracy praktycznej i projektów, które ożywiają lekcje chemii.</p><span class="tag-in">W cenie pakietu</span></div></div>
    </div>
  </div>
</section>

<!-- BONUSY -->
<section class="bonus">
  <div class="wrap">
    <div class="center narrow">
      <h2>🎁 3 bonusy w cenie pakietu</h2>
      <p class="lead">Bez dodatkowych opłat — otrzymasz je od razu po zakupie.</p>
    </div>
    <div class="grid g3" style="margin-top:30px">
      <div class="card"><span class="bn">BONUS 1</span><h3>30 tygodni planów lekcji</h3><p>Pomaga uporządkować pracę w ciągu roku i szybciej przygotować kolejne zajęcia.</p><span class="tag-in">W cenie pakietu</span></div>
      <div class="card"><span class="bn">BONUS 2</span><h3>Bank ewaluacji i sprawdzianów</h3><p>Gotowe narzędzia do sprawdzania postępów uczniów bez tworzenia każdej oceny od zera.</p><span class="tag-in">W cenie pakietu</span></div>
      <div class="card"><span class="bn">BONUS 3</span><h3>Klucz odpowiedzi i przewodnik metodyczny</h3><p>Ułatwia sprawdzanie prac oraz prowadzenie lekcji z większą pewnością i spójnością.</p><span class="tag-in">W cenie pakietu</span></div>
    </div>
  </div>
</section>

<!-- OFERTA -->
<section class="offer-sec" id="oferta">
  <div class="wrap">
    <div class="center narrow">
      <h2>Dzisiaj otrzymujesz cały system</h2>
    </div>
    <div class="offer">
      <h3>Wizualna Chemia™ | Edycja 2026</h3>
      <ul>
        <li>Tom 01 — Budowa atomu i układ okresowy</li>
        <li>Tom 02 — Wiązania chemiczne i hybrydyzacja</li>
        <li>Tom 03 — Reakcje chemiczne</li>
        <li>Tom 04 — Roztwory i stężenia</li>
        <li>Tom 05 — Kwasy, zasady i pH</li>
        <li>Tom 06 — Chemia organiczna</li>
        <li>Tom 07 — Doświadczenia laboratoryjne i projekty</li>
        <li class="b">🎁 BONUS 1 — 30 tygodni planów lekcji</li>
        <li class="b">🎁 BONUS 2 — Bank ewaluacji i sprawdzianów</li>
        <li class="b">🎁 BONUS 3 — Klucz odpowiedzi i przewodnik metodyczny</li>
      </ul>
      <div class="totals">
        <div><b>10</b><span>elementów edukacyjnych</span></div>
        <div><b>568</b><span>stron gotowych do wydruku</span></div>
      </div>
      <div class="pricebox">
        <span class="promo">Oferta premierowa: −50%</span>
        <p class="old">Cena regularna: <s>129,98 zł</s></p>
        <p class="now">64,99 zł</p>
        <p class="save">Oszczędzasz 64,99 zł</p>
        <div class="timer">
          <p>⏳ Utrzymujemy dla Ciebie rabat −50% jeszcze przez:</p>
          <div class="clock">
            <div class="box"><b data-min>15</b><small>MIN.</small></div>
            <span class="sep">:</span>
            <div class="box"><b data-seg>00</b><small>SEK.</small></div>
          </div>
          <p class="fin">Czas rezerwacji minął. Jeśli nadal widzisz cenę 64,99 zł, rabat jest jeszcze aktywny — zamów teraz.</p>
        </div>
        <p class="once">Jednorazowa płatność • Bez abonamentu • Dostęp cyfrowy od razu</p>
        <a class="btn big cta checkout" href="${CHECKOUT}">Uzyskaj natychmiastowy dostęp</a>
        ${BLIK}
      </div>
    </div>
  </div>
</section>

<!-- PODGLĄD MATERIAŁÓW -->
<section>
  <div class="wrap">
    <div class="center narrow">
      <span class="eyebrow">👀 Zobacz materiały od środka</span>
      <h2>Zobacz, co znajdziesz w środku</h2>
      <p class="lead">Gotowe do użycia materiały wizualne, karty pracy, eksperymenty i narzędzia, które oszczędzają czas nauczyciela.</p>
    </div>
    <div class="car">
      <button class="arr prev" aria-label="Poprzedni">‹</button>
      <div class="track" id="track">
        <div class="slide"><img loading="lazy" src="https://cdn.magicpatterns.com/uploads/wqBXAZTRUysx5Fa8uCXpiH/01-wiazania-struktura-lewisa.webp" alt="Struktura Lewisa"><p>Struktura Lewisa</p><small>Wiązania chemiczne</small></div>
        <div class="slide"><img loading="lazy" src="https://cdn.magicpatterns.com/uploads/1tQSYvp1BBVkwezSUJYFDe/02-wiazania-trzy-typy-wiazan.webp" alt="Trzy typy wiązań"><p>Trzy typy wiązań</p><small>Wiązania chemiczne</small></div>
        <div class="slide"><img loading="lazy" src="https://cdn.magicpatterns.com/uploads/aX3tcxCxhYZbLoHmU26GsS/03-reakcje-strategie-balansowania.webp" alt="Strategie bilansowania równań"><p>Strategie bilansowania równań</p><small>Reakcje chemiczne</small></div>
        <div class="slide"><img loading="lazy" src="https://cdn.magicpatterns.com/uploads/pQen9bbwU9PgQg3yVgfVxe/04-reakcje-metoda-mostow-jednostkowych.webp" alt="Metoda mostów jednostkowych"><p>Metoda mostów jednostkowych</p><small>Reakcje chemiczne</small></div>
        <div class="slide"><img loading="lazy" src="https://cdn.magicpatterns.com/uploads/h8nr9KrsEa5Z6j6DahPtCq/05-laboratorium-wulkan-chemiczny.webp" alt="Wulkan chemiczny"><p>Wulkan chemiczny</p><small>Laboratorium</small></div>
        <div class="slide"><img loading="lazy" src="https://cdn.magicpatterns.com/uploads/h8VNhwyMo7VB6LPGUfUdDe/06-laboratorium-chemiluminescencja.webp" alt="Chemiluminescencja"><p>Chemiluminescencja</p><small>Laboratorium</small></div>
        <div class="slide"><img loading="lazy" src="https://cdn.magicpatterns.com/uploads/bR3DfNPfX8NSVevTibdryf/07-laboratorium-projekt-ph-codzienny.webp" alt="Projekt: pH na co dzień"><p>Projekt: pH na co dzień</p><small>Laboratorium</small></div>
        <div class="slide"><img loading="lazy" src="https://cdn.magicpatterns.com/uploads/urhQW2V8BbqrXwVfp9WC45/08-bonus-plan-roczny-30-tygodni.webp" alt="Plan roczny na 30 tygodni"><p>Plan roczny na 30 tygodni</p><small>Bonus 1</small></div>
        <div class="slide"><img loading="lazy" src="https://cdn.magicpatterns.com/uploads/tjuvUTRKkmxmWiNpvCkKCe/09-bonus-bank-175-pytan.webp" alt="Bank pytań i sprawdzianów"><p>Bank pytań i sprawdzianów</p><small>Bonus 2</small></div>
        <div class="slide"><img loading="lazy" src="https://cdn.magicpatterns.com/uploads/4RjoS5Rxwb7fZFB2aG1zAv/10-bonus-klucz-odpowiedzi-atom.webp" alt="Klucz odpowiedzi"><p>Klucz odpowiedzi</p><small>Bonus 3</small></div>
      </div>
      <button class="arr next" aria-label="Następny">›</button>
      <div class="dots" id="dots"></div>
    </div>
    <div class="center" style="margin-top:28px">
      <a class="btn big cta" href="#oferta">Chcę otrzymać pełny zestaw</a>
    </div>
  </div>
</section>

<!-- DLA KOGO -->
<section class="compare fit">
  <div class="wrap">
    <div class="grid g2">
      <div class="card yes">
        <h3>To jest dla Ciebie, jeśli…</h3>
        <ul>
          <li>Uczysz chemii w klasach 7–8, liceum lub technikum.</li>
          <li>Chcesz mieć materiały wizualne i gotowe do użycia.</li>
          <li>Potrzebujesz spójnego systemu, a nie kolejnych przypadkowych kart pracy.</li>
          <li>Chcesz skrócić czas przygotowania lekcji.</li>
          <li>Zależy Ci na większym zaangażowaniu uczniów.</li>
        </ul>
      </div>
      <div class="card no">
        <h3>To nie jest dla Ciebie, jeśli…</h3>
        <ul>
          <li>Szukasz kursu wideo lub formalnej certyfikacji.</li>
          <li>Potrzebujesz fizycznego zestawu wysyłanego pocztą.</li>
          <li>Chcesz programu tworzonego wyłącznie dla jednej szkoły.</li>
          <li>Nie planujesz korzystać z materiałów cyfrowych i drukowanych.</li>
        </ul>
      </div>
    </div>
  </div>
</section>

<!-- JAK WYKORZYSTAĆ -->
<section>
  <div class="wrap">
    <div class="center narrow"><h2>Jak nauczyciele mogą wykorzystać Wizualną Chemię™</h2></div>
    <div class="grid g3" style="margin-top:30px">
      <div class="card"><div class="num">01</div><h3>Wyjaśniaj</h3><p>Wizualne strony pomagają wprowadzać trudne pojęcia krok po kroku.</p></div>
      <div class="card"><div class="num">02</div><h3>Ćwicz</h3><p>Gotowe zadania pozwalają uczniom pracować samodzielnie, w parach lub grupach.</p></div>
      <div class="card"><div class="num">03</div><h3>Sprawdzaj</h3><p>Sprawdziany, klucze i materiały wspierają powtórkę oraz ocenę postępów.</p></div>
    </div>
  </div>
</section>

<!-- JAK TO DZIAŁA -->
<section class="compare">
  <div class="wrap">
    <div class="center narrow"><h2>Jak to działa</h2></div>
    <div class="grid g3" style="margin-top:30px">
      <div class="card"><div class="num">01</div><h3>Dokonaj bezpiecznej płatności</h3><p>Jednorazowa płatność za cały pakiet — możesz zapłacić BLIK-iem.</p></div>
      <div class="card"><div class="num">02</div><h3>Odbierz dostęp cyfrowy</h3><p>Po zakupie otrzymasz materiały w formie cyfrowej.</p></div>
      <div class="card"><div class="num">03</div><h3>Pobierz, wydrukuj i ucz</h3><p>Wybierz materiały potrzebne na najbliższą lekcję i wykorzystaj je w swojej klasie.</p></div>
    </div>
  </div>
</section>

<!-- CIERRE -->
<section class="final">
  <div class="wrap narrow">
    <h2>Mniej szukania. Więcej jasnych lekcji.</h2>
    <p class="sub">Chemia gotowa wtedy, kiedy jej potrzebujesz.</p>
    <ul>
      <li>7 kompletnych tomów</li>
      <li>3 bonusy dla nauczyciela</li>
      <li>568 stron gotowych do wydruku</li>
      <li>Materiały po polsku</li>
      <li>Dostęp cyfrowy zaraz po zakupie</li>
      <li>Jednorazowa płatność: 64,99 zł</li>
    </ul>
    <a class="btn big cta checkout" href="${CHECKOUT}">Rozpocznij z Wizualną Chemią™</a>
    ${BLIK}
    <p class="meta">Bez abonamentu • Dostęp cyfrowy od razu</p>
  </div>
</section>

<!-- FAQ -->
<section class="faq">
  <div class="wrap narrow">
    <h2 class="center" style="margin-bottom:28px">Najczęstsze pytania</h2>
    <details><summary>Co dokładnie otrzymam?</summary><p>Otrzymasz dostęp cyfrowy do 7 tomów Wizualnej Chemii™ oraz 3 bonusów dla nauczyciela: planów lekcji na 30 tygodni, banku ewaluacji i sprawdzianów oraz klucza odpowiedzi z przewodnikiem metodycznym.</p></details>
    <details><summary>Jak mogę zapłacić?</summary><p>Możesz zapłacić BLIK-iem — wystarczy 6-cyfrowy kod z aplikacji Twojego banku. Płatność jest jednorazowa i bezpieczna.</p></details>
    <details><summary>Czy to produkt fizyczny?</summary><p>Nie. To produkt cyfrowy: materiały pobierasz i drukujesz samodzielnie, tyle razy, ile potrzebujesz. Nic nie jest wysyłane pocztą.</p></details>
    <details><summary>Kiedy otrzymam materiały?</summary><p>Zaraz po potwierdzeniu płatności dostęp trafia na adres e-mail podany przy zakupie. Jeśli nie widzisz wiadomości, sprawdź folder „Spam” lub „Oferty”.</p></details>
    <details><summary>Czy to abonament?</summary><p>Nie. Płacisz tylko raz — bez abonamentu i bez automatycznych odnowień. Z materiałów możesz korzystać także w kolejnych latach szkolnych.</p></details>
    <details><summary>Dla jakich klas przeznaczone są materiały?</summary><p>Dla klas 7–8 szkoły podstawowej, liceum i technikum.</p></details>
    <details><summary>Czy klucze odpowiedzi są w zestawie?</summary><p>Tak. Klucz odpowiedzi i przewodnik metodyczny to Bonus 3, który otrzymujesz w cenie pakietu.</p></details>
    <details><summary>Czy mogę używać materiałów z własnymi uczniami?</summary><p>Tak. Materiały są przeznaczone do Twojej pracy z uczniami — na lekcjach, zajęciach dodatkowych i korepetycjach. Nie można ich odsprzedawać ani udostępniać publicznie.</p></details>
  </div>
</section>

<footer>
  <b>WIZUALNA CHEMIA™</b>
  <p style="margin-top:6px">Edycja 2026 © 2026</p>
  <p style="margin-top:10px">Produkt cyfrowy • Jednorazowa płatność • Bez abonamentu</p>
  <p style="max-width:520px;margin:10px auto 0">Materiały przeznaczone do własnej pracy nauczyciela z uczniami.</p>
</footer>

<div class="sticky" id="sticky">
  <div class="p">64,99 zł<small>Rabat −50%: <b><span data-min>15</span>:<span data-seg>00</span></b> • BLIK</small></div>
  <a class="btn cta checkout" href="${CHECKOUT}">Chcę dostęp</a>
</div>`;
export function App() {
  useEffect(() => {
    // evita doble carga (se marca en el propio DOM, así funciona también al recargar la vista previa)
    const raiz = document.getElementById("particulas");
    if (!raiz || raiz.dataset.wcInit) return;
    raiz.dataset.wcInit = "1";
    try {
      // si algo falla, la página igual se ve (solo se pierde esa parte interactiva)
      document.documentElement.classList.add("js");
      document.documentElement.lang = "pl";
      document.title = "Wizualna Chemia™ | Edycja 2026 — materiały dla nauczycieli chemii";
      let md = document.querySelector('meta[name="description"]');
      if (!md) {
        md = document.createElement("meta");
        md.setAttribute("name", "description");
        document.head.appendChild(md);
      }
      md.setAttribute("content", "7 kompletnych tomów i 3 bonusy dla nauczycieli chemii: 568 stron gotowych do wydruku dla klas 7–8, liceum i technikum. Dostęp cyfrowy od razu.");

      // Fuentes
      if (!document.getElementById("wc-fonts")) {
        const l = document.createElement("link");
        l.id = "wc-fonts";
        l.rel = "stylesheet";
        l.href = "https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&family=Poppins:wght@600;700;800;900&display=swap";
        document.head.appendChild(l);
      }

      // Meta Pixel (el mismo que ya tenía la página polaca)
      if (!window.fbq) {
        // Se agrega al <head>: no depende de que existan otros <script> en la página
        const fbq = function () {
          fbq.callMethod ? fbq.callMethod.apply(fbq, arguments) : fbq.queue.push(arguments);
        };
        fbq.push = fbq;
        fbq.loaded = true;
        fbq.version = "2.0";
        fbq.queue = [];
        window.fbq = fbq;
        if (!window._fbq) window._fbq = fbq;
        const sc = document.createElement("script");
        sc.async = true;
        sc.src = "https://connect.facebook.net/en_US/fbevents.js";
        document.head.appendChild(sc);
        window.fbq('init', '1481216457390096');
        window.fbq('track', 'PageView');
      }
      const $$ = s => document.querySelectorAll(s);

      /* Pixel: InitiateCheckout al ir al checkout */
      $$(".checkout").forEach(a => a.addEventListener("click", () => {
        try {
          window.fbq("track", "InitiateCheckout", {
            value: 64.99,
            currency: "PLN",
            content_name: "Wizualna Chemia PL"
          });
        } catch (e) {}
      }));

      /* Contador de 15 minutos: arranca en la primera visita y NO se reinicia al recargar */
      (function () {
        const DURACION = 15 * 60 * 1000,
          CLAVE = "wc_rabat_fin";
        let fin = 0;
        try {
          fin = Number(localStorage.getItem(CLAVE)) || 0;
        } catch (e) {}
        if (!fin) {
          fin = Date.now() + DURACION;
          try {
            localStorage.setItem(CLAVE, String(fin));
          } catch (e) {}
        }
        const mins = $$("[data-min]"),
          segs = $$("[data-seg]"),
          cajas = $$(".timer");
        let id;
        const tick = () => {
          const r = Math.max(0, fin - Date.now());
          const m = String(Math.floor(r / 60000)).padStart(2, "0"),
            s = String(Math.floor(r % 60000 / 1000)).padStart(2, "0");
          mins.forEach(e => e.textContent = m);
          segs.forEach(e => e.textContent = s);
          cajas.forEach(c => {
            c.classList.toggle("ultimo", r > 0 && r < 60000);
            c.classList.toggle("cero", r === 0);
          });
          if (r === 0) clearInterval(id);
        };
        tick();
        id = setInterval(tick, 1000);
      })();

      /* Carrusel */
      (function () {
        const track = document.getElementById("track"),
          dots = document.getElementById("dots");
        const slides = track.children,
          n = slides.length;
        for (let i = 0; i < n; i++) {
          const b = document.createElement("button");
          b.setAttribute("aria-label", "Slajd " + (i + 1));
          b.onclick = () => ir(i);
          dots.appendChild(b);
        }
        const ir = i => track.scrollTo({
          left: slides[(i + n) % n].offsetLeft - track.offsetLeft,
          behavior: "smooth"
        });
        const actual = () => Math.round(track.scrollLeft / track.clientWidth);
        const marcar = () => [...dots.children].forEach((d, i) => d.classList.toggle("on", i === actual()));
        track.addEventListener("scroll", () => requestAnimationFrame(marcar));
        document.querySelector(".arr.prev").onclick = () => ir(actual() - 1);
        document.querySelector(".arr.next").onclick = () => ir(actual() + 1);
        marcar();
      })();

      /* Flecha animada dentro de cada CTA */
      $$(".btn.big, .btn.cta").forEach(b => {
        if (!b.querySelector(".fl")) b.insertAdjacentHTML("beforeend", ' <span class="fl">→</span>');
      });

      /* Aparición al hacer scroll */
      (function () {
        const els = $$("h2, .card, .slide, .offer, .faq details");
        els.forEach((e, i) => {
          e.classList.add("rv");
          e.style.transitionDelay = i % 3 * 90 + "ms";
        });
        if (!("IntersectionObserver" in window)) {
          els.forEach(e => e.classList.add("in"));
          return;
        }
        const io = new IntersectionObserver(es => es.forEach(x => {
          if (x.isIntersecting) {
            x.target.classList.add("in");
            io.unobserve(x.target);
            setTimeout(() => x.target.style.transitionDelay = "", 1000);
          }
        }), {
          threshold: .12
        });
        els.forEach(e => io.observe(e));
      })();

      /* Partículas flotantes: átomos, electrones, protones y neutrones */
      (function () {
        if (matchMedia("(prefers-reduced-motion: reduce)").matches) return;
        const capa = document.getElementById("particulas");
        const movil = innerWidth < 760;
        const N = movil ? 9 : 18;
        const atomo = (c1, c2) => `<svg viewBox="0 0 100 100"><circle cx="50" cy="50" r="9" fill="${c1}"/>
    <g class="orb" style="--g:7s"><ellipse cx="50" cy="50" rx="44" ry="16" fill="none" stroke="${c2}" stroke-width="2.5"/><circle cx="94" cy="50" r="5" fill="${c2}"/></g>
    <g class="orb r" style="--g:9s"><ellipse cx="50" cy="50" rx="44" ry="16" fill="none" stroke="${c2}" stroke-width="2.5" transform="rotate(60 50 50)"/><circle cx="72" cy="88" r="5" fill="${c2}"/></g>
    <g class="orb" style="--g:11s"><ellipse cx="50" cy="50" rx="44" ry="16" fill="none" stroke="${c2}" stroke-width="2.5" transform="rotate(-60 50 50)"/><circle cx="28" cy="88" r="5" fill="${c2}"/></g></svg>`;
        const bola = (c, t) => `<svg viewBox="0 0 100 100"><circle cx="50" cy="50" r="40" fill="${c}"/><text x="50" y="64" text-anchor="middle" font-family="Poppins,sans-serif" font-weight="800" font-size="40" fill="#fff">${t}</text></svg>`;
        const tipos = [{
          html: () => atomo("#2563eb", "#14b8a6"),
          s: [60, 110],
          o: .15
        }, {
          html: () => atomo("#0f6a82", "#2563eb"),
          s: [50, 90],
          o: .14
        }, {
          html: () => bola("#ef4444", "+"),
          s: [18, 30],
          o: .22
        },
        // protón
        {
          html: () => bola("#64748b", "n"),
          s: [18, 28],
          o: .20
        },
        // neutrón
        {
          html: () => bola("#14b8a6", "e⁻"),
          s: [12, 20],
          o: .26
        },
        // electrón
        {
          html: () => bola("#2563eb", "e⁻"),
          s: [12, 18],
          o: .24
        }];
        const r = (a, b) => a + Math.random() * (b - a);
        for (let i = 0; i < N; i++) {
          const t = tipos[i % tipos.length],
            s = r(t.s[0], t.s[1]) * (movil ? .75 : 1);
          const d = document.createElement("div");
          d.className = "pt";
          // la mayoría por los costados para no tapar el texto central
          const lado = Math.random() < .8 ? Math.random() < .5 ? r(0, 14) : r(84, 97) : r(15, 84);
          d.style.cssText = `left:${lado}vw;top:${r(0, 95)}vh;width:${s}px;height:${s}px;--o:${t.o};--t:${r(18, 34)}s;animation-delay:-${r(0, 20)}s;` + `--dx1:${r(-60, 60)}px;--dy1:${r(-90, 90)}px;--dx2:${r(-80, 80)}px;--dy2:${r(-120, 120)}px;--dx3:${r(-50, 50)}px;--dy3:${r(-80, 80)}px`;
          d.innerHTML = t.html();
          capa.appendChild(d);
        }
        // leve paralaje con el scroll
        addEventListener("scroll", () => {
          capa.style.transform = `translateY(${Math.sin(scrollY / 500) * 30}px)`;
        }, {
          passive: true
        });
      })();

      /* Barra fija en móvil: aparece después del hero, se oculta en la oferta */
      (function () {
        const s = document.getElementById("sticky"),
          hero = document.querySelector(".hero"),
          of = document.getElementById("oferta");
        const upd = () => {
          const pasóHero = hero.getBoundingClientRect().bottom < 0;
          const r = of.getBoundingClientRect(),
            enOferta = r.top < innerHeight && r.bottom > 0;
          s.classList.toggle("show", pasóHero && !enOferta);
        };
        addEventListener("scroll", upd, {
          passive: true
        });
        upd();
      })();
    } catch (err) {
      console.error("Wizualna Chemia init:", err);
    }
  }, []);
  return <>
      <style data-id="element-0" data-mp="3q1r2uf3906gr">{CSS}</style>
      <div id="particulas" aria-hidden="true" data-id="element-1" data-mp="3q2aifp5feirm"></div>
      <div dangerouslySetInnerHTML={{
      __html: MARKUP
    }} data-id="element-2" data-mp="3pzo2p28dswyb" />
    </>;
}
export default App;